// extracted by mini-css-extract-plugin
export var carrierIcon = "_xm-0";
export var carrierLogo = "_xm-1";
export var detailsSection = "_xm-2";